import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from './components/layout/root-layout';
import { HomePage } from './pages/home';
import { ProductsPage } from './pages/products';
import { ProductPage } from './pages/product';
import { CartPage } from './pages/cart';
import { SettingsPage } from './pages/settings';
import { CategoriesPage } from './pages/categories';
import { WishlistPage } from './pages/wishlist';
import { TrackPage } from './pages/track';
import { AboutPage } from './pages/about';
import { ContactPage } from './pages/contact';
import { OrderCompletePage } from './pages/order-complete';
import { FAQPage } from './pages/faq';
import { ReturnPolicyPage } from './pages/return-policy';
import { PrivacyPolicyPage } from './pages/privacy-policy';
import { TermsOfServicePage } from './pages/terms-of-service';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'home', element: <HomePage /> },
      { path: 'products', element: <ProductsPage /> },
      { path: 'product/:id', element: <ProductPage /> },
      { path: 'cart', element: <CartPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'categories', element: <CategoriesPage /> },
      { path: 'wishlist', element: <WishlistPage /> },
      { path: 'track', element: <TrackPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'order-complete', element: <OrderCompletePage /> },
      { path: 'faq', element: <FAQPage /> },
      { path: 'return-policy', element: <ReturnPolicyPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms-of-service', element: <TermsOfServicePage /> },
    ],
  },
]);